import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PixMenu } from '../models/pix-menu.enum';

@Component({
	selector: 'app-pix-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixHomeComponent implements OnInit {
	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router
	) {}

	ngOnInit(): void {
		const validateOnboarding = this.activatedRoute.snapshot.paramMap.get("validateOnboarding");

		if(validateOnboarding === null){
			this.validateOnboarding()
			return;
		}

		if(!validateOnboarding){
			this.redirectToOnboarding();
			return;
		}
	}

	validateOnboarding() {
		if (new Date().getTime() <= new Date('01/31/2022').getTime()) {
			const item = localStorage.getItem('showOnboardingPixNew');

			if (item === null) {
				this.redirectToOnboarding();
			}
		}
	}

	redirectToOnboarding() {
		this.router.navigate(['pix/onboarding']);
	}

	get pixMenu(): typeof PixMenu {
		return PixMenu;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/home/home.component.ts